import React from 'react';
import { Redirect, Route, Switch, useParams } from 'wouter';
import { EditorPage } from '../canvas/EditorPage';
import { RedirectToHref } from '../common/RedirectToHref';

const RouteToEntity = () => {
    const { entityId } = useParams<{ entityId: string, param?: string }>();
    switch (entityId.slice(0, 2)) {
        case 'BO': return <EditorPage />;
        default: return <RedirectToHref href="/app" />;
    }
};

export const GuestSwitch = () => {
    return <Switch>
        <Route path="/board/:entityId">
            <Redirect to="~/:entityId" />
        </Route>
        <Route path="/:entityId" component={RouteToEntity} />
        <Route path="*">
            <RedirectToHref href="/app" />
        </Route>
    </Switch>;
};
